import React from 'react';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import FilterMonthYearPicker from '../../CustomDates/FilterMonthYearPicker/FilterMonthYearPicker';
import BiMonthlyPeriodModal from '../../../ClientDetails/Modals/BiMonthlyPeriodModal';
import tb from '../../../ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import { XtramButton, XtramSelect } from '../../XtramModal/XtramModal';
import styles from '../ReportModalXtram.module.scss';

const formatDateToYearMonth = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    return `${year}/${month}`;
};

/** The period the report covers (same controls as the advances section of the client page), the partner and the comparative report. */
const WithholdingModalHeader = ({
    t,
    direction,
    isRange,
    isBiMonthly,
    date,
    startDate,
    endDate,
    biStartDate,
    biEndDate,
    showBiMonth,
    setShowBiMonth,
    handleDateChangeNew,
    handleStartDateChangeNew,
    handleEndDateChangeNew,
    handleBiMonthDate,
    handleRangeChange,
    handleDownloadComparativeAdvance,
    partners,
    internalSelectedPartner,
    handlePartnerChange,
    isSubordinateClient,
}) => {
    const partnerOptions = (partners || []).map((p) => ({ value: p.id, label: `${p.name} (${p.equity}%)` }));

    return (
        <div className={styles.toolbar} dir={direction}>
            <div className={styles.periodGroup}>
                {handleRangeChange && (
                    <label className={`${tb.switchRow} ${tb[direction] || ''}`} dir={direction}>
                        <span>{t('DateRange')}</span>
                        <input type="checkbox" checked={!!isRange} onChange={handleRangeChange} />
                        <span className={tb.switchTrack} aria-hidden="true" />
                    </label>
                )}

                {isRange ? (
                    <div className={tb.dateSelectRange}>
                        <div className={tb.dateSelect}>
                            <FilterMonthYearPicker
                                year={startDate}
                                month={startDate}
                                onYearChange={(v) => handleStartDateChangeNew(v, 'year')}
                                onMonthChange={(v) => handleStartDateChangeNew(v, 'month')}
                                labelYear={t('StartYear')}
                                labelMonth={t('StartMonth')}
                                direction={direction}
                            />
                        </div>
                        <div className={tb.rangeDivider} />
                        <div className={tb.dateSelect}>
                            <FilterMonthYearPicker
                                year={endDate}
                                month={endDate}
                                onYearChange={(v) => handleEndDateChangeNew(v, 'year')}
                                onMonthChange={(v) => handleEndDateChangeNew(v, 'month')}
                                labelYear={t('EndYear')}
                                labelMonth={t('EndMonth')}
                                direction={direction}
                            />
                        </div>
                    </div>
                ) : isBiMonthly ? (
                    <>
                        <button type="button" className={tb.periodSelect} onClick={() => setShowBiMonth(true)}>
                            <CalendarTodayOutlinedIcon />
                            <span className={tb.periodSelectValue}>
                                <span>{formatDateToYearMonth(biStartDate.toISOString())}</span>
                                <span> - </span>
                                <span>{formatDateToYearMonth(biEndDate.toISOString())}</span>
                            </span>
                        </button>
                        <BiMonthlyPeriodModal
                            visible={showBiMonth}
                            onClose={() => setShowBiMonth(false)}
                            date={biStartDate}
                            t={t}
                            onDateChange={(start, end) => handleBiMonthDate(start, end)}
                        />
                    </>
                ) : (
                    <div className={tb.dateSelect}>
                        <FilterMonthYearPicker
                            year={date}
                            month={date}
                            onYearChange={(v) => handleDateChangeNew(v, 'year')}
                            onMonthChange={(v) => handleDateChangeNew(v, 'month')}
                            labelYear={t('Year')}
                            labelMonth={t('Month')}
                            direction={direction}
                        />
                    </div>
                )}

                {partnerOptions.length > 0 && (
                    <div className={styles.partnerSelect}>
                        <XtramSelect
                            direction={direction}
                            options={partnerOptions}
                            value={partnerOptions.find((o) => o.value === internalSelectedPartner) || null}
                            onChange={(option) => option && handlePartnerChange(option.value)}
                            placeholder={t('Partner')}
                            disabled={isSubordinateClient}
                            disableClearable
                        />
                    </div>
                )}
            </div>

            <XtramButton variant="secondary" small onClick={handleDownloadComparativeAdvance}>
                <CompareArrowsIcon sx={{ fontSize: 18 }} />
                {t('ComparativeAdvancesReport')}
            </XtramButton>
        </div>
    );
};

export default WithholdingModalHeader;
